import type { LiveChatState } from '.';

const initialState: LiveChatState = {
  agentIcon: undefined,
  agentName: 'Live Support Agent',
  agentTyping: false,
  chatId: '',
  deploymentConfiguration: null,
  integration: undefined,
  integrationConfig: {
    integrationId: '',
  },
  isEndLiveChatModalVisible: false,
  isInAssistantMode: false,
  jwt: '',
  liveChatQuery: '',
  queuePosition: undefined,
  status: undefined,
  submitted_csat_result: {},
  userEndedChat: false,
  waitTimeMessage: null,
};

export default initialState;
